module.exports = __webpack_public_path__ + "static/media/eagles.aaae36c5.jpg";